import Toast from '../../../../node_modules/bootstrap/js/src/toast'
const notification = {
  elMsg: '',
  el: '',
  init() {
    this.el = $q('.toast')
    this.elMsg = $q('.toast-body')

    if (!this.el.first) return

    window.notification = new Toast(this.el.first)
    this.el.listen('hidden.bs.toast', () => (this.elMsg.first.innerText = ''))
  },
  message(msg) {
    if (!this.elMsg.first) return

    this.elMsg.first.innerText = msg
    window.notification.show()
  }
}
export default notification
